import { Button, Flex, InputNumber, Space } from 'antd';
import SearchInput from '../SearchInput';
import { useRequest, useSetState } from 'ahooks';
import { mediaBoxApi, MediaBoxItemRes } from '@/axios/mediaBox';
import { ColumnsType, TableProps } from 'antd/es/table';
import CommonTable from '../Table';
import CustomSelect from '../Base/Select';
import { useState } from 'react';

const MediaBox = ({ onAdd, ...props }: { onAdd?: (item: MediaBoxItemRes) => void } & TableProps<MediaBoxItemRes>) => {
  const [searchParams, setSearchParams] = useSetState({
    pageIndex: 1,
    pageSize: 10,
    mediaName: '',
    channels: [] as string[],
    minPrice: undefined as number | undefined,
    maxPrice: undefined as number | undefined,
  });
  const [tempChannels, setTempChannels] = useState<string[]>([]);
  const [tempMinPrice, setTempMinPrice] = useState<number | undefined>();
  const [tempMaxPrice, setTempMaxPrice] = useState<number | undefined>();
  const {
    data,
    loading,
    runAsync: refreshList,
  } = useRequest(() => mediaBoxApi.list(searchParams), {
    refreshDeps: [searchParams],
  });
  const { data: channels = [] } = useRequest(() => mediaBoxApi.channels());
  const columns: ColumnsType<MediaBoxItemRes> = [
    {
      title: '媒体名称',
      dataIndex: 'mediaName',
      width: 100,
    },
    {
      title: '链接情况',
      dataIndex: 'linkType',
      width: 100,
      render: (linkType: number) => {
        // 链接类型 0不带联系方式 1超链接 2网址 3微信QQ
        switch (linkType) {
          case 0:
            return '不带联系方式';
          case 1:
            return '超链接';
          case 2:
            return '网址';
          case 3:
            return '微信QQ';
          default:
            return '-';
        }
      },
    },
    {
      title: '平台',
      dataIndex: 'channelType',
      width: 80,
    },
    {
      title: '渠道',
      dataIndex: 'displayChannel',
      width: 120,
      filtered: searchParams.channels.length > 0,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Flex vertical gap={8}>
            <CustomSelect
              mode="multiple"
              allowClear
              maxTagCount="responsive"
              placeholder="请选择渠道"
              style={{ width: 220 }}
              value={tempChannels}
              options={channels.map((item) => ({
                value: item.code,
                label: item.name,
              }))}
              onChange={(value) => {
                setTempChannels(value);
              }}
            />
            <Space>
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  setSearchParams({ channels: tempChannels, pageIndex: 1 });
                  confirm();
                }}
              >
                确定
              </Button>
              <Button
                size="small"
                onClick={() => {
                  setTempChannels([]);
                  setSearchParams({ channels: [], pageIndex: 1 });
                  clearFilters?.();
                }}
              >
                重置
              </Button>
            </Space>
          </Flex>
        </div>
      ),
    },
    {
      title: '价格',
      dataIndex: 'price',
      width: 80,
      filtered: searchParams.minPrice != null || searchParams.maxPrice != null,
      filterDropdown: ({ confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Flex vertical gap={8}>
            <Space>
              <InputNumber
                placeholder="最低价格"
                min={0}
                precision={2}
                value={tempMinPrice}
                onChange={(value) => {
                  setTempMinPrice(value === null ? undefined : Number(value));
                }}
                style={{ width: 120 }}
              />
              <span>-</span>
              <InputNumber
                placeholder="最高价格"
                min={0}
                precision={2}
                value={tempMaxPrice}
                onChange={(value) => {
                  setTempMaxPrice(value === null ? undefined : Number(value));
                }}
                style={{ width: 120 }}
              />
            </Space>
            <Space>
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  setSearchParams({ minPrice: tempMinPrice, maxPrice: tempMaxPrice, pageIndex: 1 });
                  confirm();
                }}
              >
                确定
              </Button>
              <Button
                size="small"
                onClick={() => {
                  setTempMinPrice(undefined);
                  setTempMaxPrice(undefined);
                  setSearchParams({ minPrice: undefined, maxPrice: undefined, pageIndex: 1 });
                  clearFilters?.();
                }}
              >
                重置
              </Button>
            </Space>
          </Flex>
        </div>
      ),
    },
    {
      title: '操作',
      dataIndex: 'operation',
      width: 80,
      render: (_: any, record: MediaBoxItemRes) => {
        return (
          <a
            onClick={() => {
              onAdd?.(record);
            }}
          >
            添加
          </a>
        );
      },
    },
  ];
  return (
    <div>
      <Flex
        align="center"
        gap={8}
        wrap
        style={{
          marginBottom: '16px',
        }}
      >
        <div>媒体</div>
        <SearchInput
          style={{
            marginLeft: 'auto',
            width: '260px',
          }}
          placeholder="请输入媒体名称"
          onSearch={(val) => {
            setSearchParams({ mediaName: val, pageIndex: 1 });
          }}
        />
      </Flex>
      <CommonTable
        columns={columns}
        dataSource={data?.records}
        loading={loading}
        pagination={{
          current: searchParams.pageIndex,
          pageSize: searchParams.pageSize,
          total: data?.total,
          onChange: (pageIndex, pageSize) => {
            setSearchParams({ pageIndex, pageSize });
          },
        }}
        {...props}
      />
    </div>
  );
};
export default MediaBox;
